import React, { Component } from "react";
import { Navigate } from "react-router-dom";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebTopPanelComponent } from "../common/selltowebtoppanel/SellToWebTopPanelComponent";
import { SellToWebRightPanelComponent } from "../common/selltowebrightpanel/SellToWebRightPanelComponent";
import { SellToWebDropdownComponent } from "../common/selltowebdropdown/SellToWebDropdownComponent";
import { SellToWebInputComponent } from "../common/selltowebinput/SellToWebInputComponent";
import { SellToWebButtonComponent } from "../common/selltowebbutton/SellToWebButtonComponent";

export class VehicleDetailsMMRComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trims: [{ description: { trim: "Select a Trim", selected: true }, disabled: true }],
            selectedTrim: null,
            mmrVehicleColors: [{ title: "Select a Paint Color", disabled: true }],
            selectedMMRVehicleColor: null,
            odometer: "",
            isVehicleConditionClicked: false,
            showSpinner: false,
            redirectTo: "",
            makePlusModel: "",
            vifNumber: null,
            imageUrl: "",
            differentColorShown: false
        };

        this.onTrimChange = this.onTrimChange.bind(this);
        this.onColorChange = this.onColorChange.bind(this);
        this.onBackButtonClick = this.onBackButtonClick.bind(this);
        this.onOdometerChange = this.onOdometerChange.bind(this);
        this.onTextKeyDown = this.onTextKeyDown.bind(this);
        this.onVehicleConditionClick = this.onVehicleConditionClick.bind(this);
        this.onMissingImage = this.onMissingImage.bind(this);
    }

    imageBaseUrl = "https://cdn.acquirecars.com/image/EVOX/VIF/";
    exteriorColorOptions = [
        {
            "value": "Beige",
            "optionName": "Beige",
            "colorBox": "Beige"
        },
        {
            "value": "Black",
            "optionName": "Black",
            "colorBox": "Black"
        },
        {
            "value": "Blue",
            "optionName": "Blue",
            "colorBox": "Blue"
        },
        {
            "value": "Brown",
            "optionName": "Brown",
            "colorBox": "Brown"
        },
        {
            "value": "Burgundy",
            "optionName": "Burgundy",
            "colorBox": "Maroon"
        },
        {
            "value": "Gold",
            "optionName": "Gold",
            "colorBox": "Gold"
        },
        {
            "value": "Gray",
            "optionName": "Gray",
            "colorBox": "Gray"
        },
        {
            "value": "Green",
            "optionName": "Green",
            "colorBox": "Green"
        },
        {
            "value": "Lime",
            "optionName": "Lime",
            "colorBox": "Lime"
        },
        {
            "value": "Off-white",
            "optionName": "Off-white",
            "colorBox": "Ivory"
        },
        {
            "value": "Orange",
            "optionName": "Orange",
            "colorBox": "Orange"
        },
        {
            "value": "Pink",
            "optionName": "Pink",
            "colorBox": "Pink"
        },
        {
            "value": "Purple",
            "optionName": "Purple",
            "colorBox": "Purple"
        },
        {
            "value": "Red",
            "optionName": "Red",
            "colorBox": "Red"
        },
        {
            "value": "Silver",
            "optionName": "Silver",
            "colorBox": "Silver"
        },
        {
            "value": "Turquoise",
            "optionName": "Turquoise",
            "colorBox": "Turquoise"
        },
        {
            "value": "White",
            "optionName": "White",
            "colorBox": "White"
        },
        {
            "value": "Yellow",
            "optionName": "Yellow",
            "colorBox": "Yellow"
        }
    ];

    componentDidMount() {
        let homeData = CommonService.getSessionStorage("homeData");
        try {
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/vehicle-details", pageType: "Consumer", isLoggedIn: "No", properties: { vin: homeData?.vin, tenantName: this.props.tenantName, siteName: this.props.siteName } });
            if (!homeData) {
                CommonService.clientAzureStorageLog("VehicleDetailsMMRComponent", "componentDidMount", "Session data missing.", "Redirect to unique-vehicle", null, null, this.props.applicationInsights);
                this.setState({ redirectTo: "/unique-vehicle" });
            }
            else {
                CommonService.clientAzureStorageLog("VehicleDetailsMMRComponent", "componentDidMount", homeData.vin, null, null, JSON.stringify(homeData), this.props.applicationInsights);

                let trims = homeData.items;
                // trims = JSON.parse(JSON.stringify(trims));
                let lsSelectedTrim = CommonService.getLocalStorage(homeData.vin + ".SelectedTrim");

                let selectedTrim = null;
                if (trims.length === 1) {
                    selectedTrim = trims[0];
                }
                else {
                    trims.unshift({ description: { trim: "Select a Trim", selected: true }, disabled: true });
                    if (lsSelectedTrim) {
                        selectedTrim = trims.find(trim => trim.description.trim === lsSelectedTrim);
                    }
                    else {
                        trims.forEach((trim) => {
                            if (trim.bestMatch) {
                                selectedTrim = trim;
                            }
                        });
                    }
                }

                let makePlusModel = "";
                if (selectedTrim) {
                    makePlusModel = selectedTrim.description.year + " " + selectedTrim.description.make + " " + selectedTrim.description.model;
                }

                this.setState({
                    trims: trims,
                    selectedTrim: selectedTrim,
                    makePlusModel: makePlusModel
                }, () => {
                    if (selectedTrim) {
                        this.loadLSVehicleDetail();
                    }
                });
            }
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "componentDidMount", homeData?.vin);
        }
    }

    loadLSVehicleDetail() {
        let homeData = CommonService.getSessionStorage("homeData");
        let odometer = "", vifNumber = null,
            mmrVehicleColors = [{ title: "Select a Paint Color", disabled: true }], selectedMMRVehicleColor = null;

        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        mmrVehicleColors = vehicleDetailsData?.mmrVehicleColors ?? mmrVehicleColors;

        let lsOdometer = CommonService.getLocalStorage(homeData.vin + ".Odometer");
        if (lsOdometer) {
            odometer = lsOdometer;
        }

        let lsVIFNumber = CommonService.getLocalStorage(homeData.vin + ".VIFNumber");
        if (lsVIFNumber) {
            vifNumber = lsVIFNumber;
        }

        let lsSelectedMMRVehicleColorCode = CommonService.getLocalStorage(homeData.vin + ".SelectedMMRVehicleColorCode");
        let lsSelectedMMRVehicleColorName = CommonService.getLocalStorage(homeData.vin + ".SelectedMMRVehicleColorName");

        if (mmrVehicleColors.length === 1) {
            selectedMMRVehicleColor = CommonService.getLocalStorage(homeData.vin + ".SelectedMMRVehicleColor");
        }
        else {
            if (lsSelectedMMRVehicleColorCode) {
                selectedMMRVehicleColor = mmrVehicleColors.find(mmrColor => mmrColor.code === lsSelectedMMRVehicleColorCode);
            }
            else if (lsSelectedMMRVehicleColorName) {
                selectedMMRVehicleColor = this.exteriorColorOptions.find(exteriorColor => exteriorColor.value === lsSelectedMMRVehicleColorName);
            }
        }

        this.setState({
            vifNumber: vifNumber,
            mmrVehicleColors: mmrVehicleColors,
            selectedMMRVehicleColor: selectedMMRVehicleColor,
            odometer: odometer
        }, () => {
            if (!vifNumber) {
                this.getMMRDetails();
            }
            if (mmrVehicleColors?.length === 1) {
                this.getOEMColors();
            }
            else {
                this.updateSelectedVehicleColor();
            }
        });
    }

    getMMRDetails() {
        let homeData = CommonService.getSessionStorage("homeData");
        try {
            let inputData = {
                vin: homeData.vin,
                year: this.state.selectedTrim.description.year.toString(),
                modelName: this.state.selectedTrim.description.model,
                makeName: this.state.selectedTrim.description.make,
                trimName: this.state.selectedTrim.description.trim
            };
            this.props.applicationInsights.trackTrace({ message: "VehicleDetailsMMRComponent/getMMRDetails", properties: { tenantName: this.props.tenantName, siteName: this.props.siteName } });
            fetch("/VehicleDetails/GetEVOXVehicle", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    if (parsedResponse && parsedResponse.table && parsedResponse.table.length > 0 && parsedResponse.table[0].vifNumber != null) {
                        let metaTag = document.createElement("meta");
                        metaTag.name = "VifNumber";
                        metaTag.content = parsedResponse.table[0].vifNumber;
                        document.head.appendChild(metaTag);
                        this.setState({
                            vifNumber: parsedResponse.table[0].vifNumber
                        }, () => {
                            this.getOEMColors();
                        });
                    }
                    else {
                        this.setState({
                            mmrVehicleColors: this.exteriorColorOptions
                        }, () => {
                            this.updateSelectedVehicleColor();
                        });
                    }
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/VehicleDetails/GetEVOXVehicle", ...parsedError, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                                console.logError(parsedError, "VehicleDetailsMMRComponent", "getMMRDetails", homeData.vin);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "VehicleDetailsMMRComponent", "getMMRDetails", homeData.vin);
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "getMMRDetails", homeData.vin);
        }
    }

    getOEMColors() {
        let homeData = CommonService.getSessionStorage("homeData");
        try {
            let inputData = {
                vifNumber: this.state.vifNumber,
                vin: homeData.vin
            };
            this.props.applicationInsights.trackTrace({ message: "VehicleDetailsMMRComponent/getOEMColors", properties: { ...inputData, tenantName: this.props.tenantName, siteName: this.props.siteName } });
            fetch("/VehicleDetails/GetEVOXOEMColors", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    if (parsedResponse && parsedResponse.length > 0) {
                        parsedResponse = parsedResponse.filter(color => !color.duplicate);
                        parsedResponse = CommonService.sortJsonData(parsedResponse, "title", "Asc");
                        parsedResponse.forEach((oemColor, index) => {
                            oemColor.colorBox = "#" + oemColor.rgb1;
                        });
                        let defaultColor;
                        if (parsedResponse.find(x => x.default)) { defaultColor = parsedResponse.find(x => x.default)[0]; }
                        if (defaultColor) {
                            let otherColor = JSON.parse(JSON.stringify(defaultColor));
                            otherColor.title = "Other";
                            parsedResponse.push(otherColor);
                        }
                        this.setState({
                            mmrVehicleColors: parsedResponse
                        }, () => {
                            this.updateSelectedVehicleColor();
                        });
                    }
                    else {
                        this.setState({
                            mmrVehicleColors: this.exteriorColorOptions
                        }, () => {
                            this.updateSelectedVehicleColor();
                        });
                    }
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 400) {
                        this.setState({
                            mmrVehicleColors: this.exteriorColorOptions
                        }, () => {
                            this.updateSelectedVehicleColor();
                        });
                    }
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/VehicleDetails/GetEVOXOEMColors", ...inputData, ...parsedError, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                                console.logError(parsedError, "VehicleDetailsMMRComponent", "getOEMColors", homeData.vin + " " + this.state.vifNumber);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "VehicleDetailsMMRComponent", "getOEMColors", homeData.vin + " " + this.state.vifNumber);
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "getOEMColors", homeData.vin + " " + this.state.vifNumber);
        }
    }

    onTrimChange(id, selectedTrim) {
        try {
            let makePlusModel = selectedTrim.description.year + " " + selectedTrim.description.make + " " + selectedTrim.description.model;

            this.setState({
                [id]: selectedTrim,
                makePlusModel: makePlusModel,
                isVehicleConditionClicked: false
            }, () => {
                this.getMMRDetails();
            });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "onTrimChange", id);
        }
    }

    onColorChange(id, selectedMMRVehicleColor) {
        let homeData = CommonService.getSessionStorage("homeData");
        try {
            if (selectedMMRVehicleColor.title) {
                let mappedExteriorColor = this.exteriorColorOptions.find(eCP => eCP.value.toLowerCase() === selectedMMRVehicleColor.simpletitle.toLowerCase());
                if (mappedExteriorColor !== null) {
                    CommonService.clientAzureStorageLog("VehicleDetailsMMRComponent", "onColorChange", homeData.vin, selectedMMRVehicleColor.title + "-" + selectedMMRVehicleColor.simpletitle, mappedExteriorColor.value, null, this.props.applicationInsights);
                }
                else {
                    CommonService.clientAzureStorageLog("VehicleDetailsMMRComponent", "onColorChange", homeData.vin, selectedMMRVehicleColor.title + "-" + selectedMMRVehicleColor.simpletitle, "NO MMR Match", null, this.props.applicationInsights);
                }
            }
            else {
                CommonService.clientAzureStorageLog("VehicleDetailsMMRComponent", "onColorChange", homeData.vin, "MMR Color", selectedMMRVehicleColor.value, null, this.props.applicationInsights);
            }
            this.setState({
                selectedMMRVehicleColor: selectedMMRVehicleColor,
                differentColorShown: false
            }, () => {
                this.updateSelectedVehicleColor();
            });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "onColorChange", id);
        }
    }

    updateSelectedVehicleColor() {
        let homeData = CommonService.getSessionStorage("homeData");
        try {
            let imageUrl = null;
            let differentColorShown = false;

            if (this.state.vifNumber) {
                if (this.state.mmrVehicleColors[0]?.title) {
                    if (this.state.selectedMMRVehicleColor?.code) {
                        imageUrl = this.imageBaseUrl + this.state.vifNumber + ".front." + this.state.selectedMMRVehicleColor.code + ".png";
                    }
                    else {
                        imageUrl = this.imageBaseUrl + this.state.vifNumber + ".front.default.png";
                        differentColorShown = this.state.selectedMMRVehicleColor ? true : false;
                    }
                }
                else {
                    imageUrl = this.imageBaseUrl + this.state.vifNumber + ".front.default.png";
                    differentColorShown = this.state.selectedMMRVehicleColor ? true : false;
                }
            }

            this.setState({
                imageUrl: imageUrl,
                differentColorShown: differentColorShown
            });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "updateSelectedVehicleColor", homeData.vin);
        }
    }

    onOdometerChange(id, value) {
        try {
            let formattedValue = value.replaceAll(",", "").replace(/[^0-9]/g, "").slice(0, 7);
            this.setState({
                [id]: formattedValue
            });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "onOdometerChange", id);
        }
    }

    onTextKeyDown(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.onVehicleConditionClick();
        }
    }

    onMissingImage() {
        try {
            let colorCode = this.state.selectedMMRVehicleColor?.code ?? "";
            let imageUrl = "";

            if (colorCode && this.state.imageUrl.indexOf(".front." + colorCode) > -1) {
                imageUrl = this.imageBaseUrl + this.state.vifNumber + ".side." + colorCode + ".png";
                this.setState({ imageUrl: imageUrl, differentColorShown: false });
            }
            else if (colorCode && this.state.imageUrl.indexOf(".side." + colorCode) > -1) {
                imageUrl = this.imageBaseUrl + this.state.vifNumber + ".front.default.png";
                this.setState({ imageUrl: imageUrl, differentColorShown: true });
            }
            else if (this.state.imageUrl.indexOf(".front.default.") > -1) {
                imageUrl = this.imageBaseUrl + this.state.vifNumber + ".side.default.png";
                this.setState({ imageUrl: imageUrl, differentColorShown: true });
            }
            else if (this.state.imageUrl.indexOf(".side.default.") > -1) {
                this.setState({ imageUrl: "", differentColorShown: false });
            }
            else {
                this.setState({ imageUrl: "", differentColorShown: false });
            }
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "onMissingImage");
        }
    }

    onBackButtonClick() {
        window.history.go(-1);
    }

    onVehicleConditionClick() {
        let homeData = CommonService.getSessionStorage("homeData");
        try {
            let inputsValid = this.state.selectedTrim?.description?.trim !== "Select a Trim"
                && this.state.selectedMMRVehicleColor && this.state.selectedMMRVehicleColor?.title !== "Select a Paint Color"
                && this.state.odometer;

            if (inputsValid) {
                this.setState({ showSpinner: true });
                let inputData = {
                    Vin: homeData.vin
                };
                this.props.applicationInsights.trackTrace({ message: "VehicleDetailsRouteComponent/onVehicleConditionClick", properties: { ...inputData, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                fetch("/VehicleDetails/GetAutoCheckData", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8;",
                        "X-XSRF-TOKEN-ACQUIRECARS": CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")
                    },
                    body: JSON.stringify(inputData),
                    credentials: "same-origin"
                })
                    .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                    .then(parsedResponse => {
                        if (parsedResponse.errors || parsedResponse.status === "Error") {
                            this.setState({
                                redirectTo: "/unique-vehicle",
                                showSpinner: false
                            });
                        }
                        else {
                            let vehicleDetailsData = {
                                trims: this.state.trims,
                                selectedTrim: this.state.selectedTrim,
                                mmrValuesReponseItemIndex: this.state.trims.length > 1 ? this.state.trims.indexOf(this.state.selectedTrim) - 1 : 0,
                                mmrVehicleColors: this.state.mmrVehicleColors,
                                selectedVehicleOEMColor: this.state.selectedMMRVehicleColor,
                                odometer: this.state.odometer,
                                makePlusModel: this.state.makePlusModel,
                                imageUrl: this.state.imageUrl,
                                differentColorShown: this.state.differentColorShown
                            };
                            let autocheckData = {
                                autocheckResponse: parsedResponse.autocheckResponse,
                                accidentCount: parsedResponse.accidentCount,
                                ownerCount: parsedResponse.ownerCount,
                                accidentDetails: parsedResponse.accidentDetails,
                                useAutocheck: parsedResponse.useAutocheck
                            }
                            vehicleDetailsData.autocheckData = autocheckData;
                            CommonService.setSessionStorage("vehicleDetailsData", vehicleDetailsData);

                            CommonService.setLocalStorage(homeData.vin + ".SelectedTrim", this.state.selectedTrim.description.trim);
                            CommonService.setLocalStorage(homeData.vin + ".VIFNumber", this.state.vifNumber);
                            CommonService.setLocalStorage(homeData.vin + ".SelectedMMRVehicleColor", this.state.selectedMMRVehicleColor);
                            CommonService.setLocalStorage(homeData.vin + ".SelectedMMRVehicleColorCode", this.state.selectedMMRVehicleColor.code ?? "");
                            CommonService.setLocalStorage(homeData.vin + ".SelectedMMRVehicleColorName", this.state.selectedMMRVehicleColor.value ?? "");
                            CommonService.setLocalStorage(homeData.vin + ".Odometer", this.state.odometer);

                            if (parsedResponse.accidentCount.toString() === "0") {
                                this.setState({ redirectTo: "/vehicle-condition" });
                            }
                            else {
                                this.setState({ redirectTo: "/vehicle-history" });
                            }
                        }
                    })
                    .catch(notOKResponse => {
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/VehicleDetails/GetAutoCheckData", ...inputData, ...parsedError, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                                    console.logError(parsedError, "VehicleDetailsRouteComponent", "onVehicleConditionClick", homeData.vin + " " + this.state.selectedTrim?.description?.trim);
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError, "VehicleDetailsRouteComponent", "onVehicleConditionClick", homeData.vin + " " + this.state.selectedTrim?.description?.trim);
                                });
                        }
                    });
            }

            this.setState({
                isVehicleConditionClicked: true
            });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsMMRComponent", "onVehicleConditionClick", homeData.vin + " " + this.state.selectedTrim?.description?.trim);
        }
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />;
        }

        let homeData = CommonService.getSessionStorage("homeData");
        let bodyHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle Details", "Default", "Body Html")?.Value ?? "";
        let selectedTrimName = this.state.selectedTrim?.description?.trim ?? "Select a Trim";

        return <>
            <SellToWebTopPanelComponent
                imageUrl={this.state.imageUrl}
                makePlusModel={this.state.makePlusModel}
                trim={selectedTrimName !== "Select a Trim" ? selectedTrimName : "–"} />
            <section className="consumer-page">
                <section className="consumer-main">
                    <section className="ac-site-body ac-vehicledetails-body" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
                    <section className="consumer-vehicledetails-form">
                        <SellToWebDropdownComponent id="selectedTrim" label="Trim" data={this.state.trims} itemKey="description.trim" className="consumer-vehicledetails-form-trim"
                            value={selectedTrimName} onSelectChange={this.onTrimChange}
                            isChecked={(selectedTrimName !== "Select a Trim")} isError={this.state.isVehicleConditionClicked && (!this.state.selectedTrim || this.state.selectedTrim.description.trim === "Select a Trim")}
                        />

                        <SellToWebDropdownComponent id="selectedMMRVehicleColor" label="Exterior Color" data={this.state.mmrVehicleColors} itemKey={this.state.mmrVehicleColors[0]?.title ? "title" : "value"} className={"consumer-vehicledetails-form-oem" + (!this.state.selectedTrim ? " consumer-vehicledetails-form-opacity" : "")} classNameItem="app-fw-500" disabled={!this.state.selectedTrim}
                            value={(this.state.selectedMMRVehicleColor?.title ?? this.state.selectedMMRVehicleColor?.value) ?? "Select a Paint Color"} onSelectChange={this.onColorChange}
                            isChecked={(this.state.selectedMMRVehicleColor && this.state.selectedMMRVehicleColor?.title !== "Select a Paint Color")} isError={this.state.isVehicleConditionClicked && !this.state.selectedMMRVehicleColor} colorBox={this.state.selectedMMRVehicleColor?.colorBox ? CommonService.checkCSSColorSupports(this.state.selectedMMRVehicleColor.colorBox) : null}
                        />

                        <SellToWebInputComponent id="odometer" appendText="Miles" placeholder="Enter Your Current Mileage" imagePath="images/miles-input.svg" className={!this.state.selectedTrim ? " consumer-vehicledetails-form-opacity" : ""} disabled={!this.state.selectedTrim}
                            value={this.state.odometer ? CommonService.formatMoney(this.state.odometer) : ""} onTextChange={this.onOdometerChange} onKeyDown={this.onTextKeyDown}
                            isChecked={this.state.odometer} isError={this.state.isVehicleConditionClicked && !this.state.odometer}
                        />

                        <div className="d-flex justify-content-end">
                            <div style={{ "cursor": "pointer", "fontSize": "12px", "fontWeight": "400", "textDecoration": "underline", "margin": "auto 30px" }} onClick={(event => { window.history.go(-1); })}>
                                <span className="bi bi-chevron-left" style={{ "marginRight": "5px", "verticalAlign": "middle" }} />
                                Go Back
                            </div>
                            <SellToWebButtonComponent onClick={this.onVehicleConditionClick} showSpinner={this.state.showSpinner} value="Vehicle Condition" />
                        </div>
                    </section>
                </section>
                <aside className="consumer-summary">
                    <SellToWebRightPanelComponent valuationMethod={"MMR"}
                        vin={homeData?.vin} makePlusModel={this.state.makePlusModel} odometer={CommonService.formatMoney(this.state.odometer)}
                        trim={selectedTrimName !== "Select a Trim" ? selectedTrimName : "–"}
                        imageUrl={this.state.imageUrl} differentColorShown={this.state.differentColorShown}
                        colorBox={this.state.selectedMMRVehicleColor?.colorBox ? CommonService.checkCSSColorSupports(this.state.selectedMMRVehicleColor.colorBox) : null}
                        colorName={this.state.selectedMMRVehicleColor?.title ?? this.state.selectedMMRVehicleColor?.value}
                        onMissingImage={this.onMissingImage} siteAttributes={this.props.siteAttributes} applicationInsights={this.state.applicationInsights}
                    />
                </aside>
            </section>
        </>;
    }
}